import styled, { css } from 'styled-components';

export const ObjectiveGroupsList = styled.div`
  padding-right: 0.5rem;
`;

export const ObjectiveGroupsListWrapper = styled.div`
  max-height: 100%;
  width: auto;
  overflow-y: auto;
  scrollbar-gutter: stable;
  &::-webkit-scrollbar {
    width: 0.7rem;
  }
  &::-webkit-scrollbar-track {
    border-radius: 60px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 60px;
  }
  @media (hover: hover) {
    /* custom css for devices where the primary input mechanism can hover */
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0);
    }
  }
  /* firefox */
  scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-bg-color);
  scrollbar-width: thin;
  :hover {
    &::-webkit-scrollbar-track {
      background-color: var(--scrollbar-bg-color);
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--scrollbar-thumb-color);
    }
  }
`;
